import { FormControl, Grid, Paper, TextField } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Route, Routes, useNavigate } from "react-router-dom";
import { IEventListData } from "../../_common/interface/event/iEventListData";
import { IFilteringViewModel } from "../../_common/interface/table";
import StyledGrid from "../../_components/grid/styledGrid";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { getDate } from "../../_helpers/dateTime.helper";
import { getMoneyFormat } from "../../_helpers/format.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { eventService } from "../../_services/event.service";
import { useContainerStyles } from "../../_styles/container.styles";
import { EventManageDrawer } from "./event-manageDrawer";
import { EventDocumentManage } from "../eventDocument/eventDocument-manage";
import { EventDocumentUpload } from "../eventDocument/eventDocument-upload";


export function EventIndex() {
    const navigate = useNavigate();
    const [data, setData] = useState<IEventListData>({ items: [], count: 0 });
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        name: '',
    });

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'status',
                header: 'Status',
            },
            {
                accessorKey: 'price',
                header: 'Price',
                accessorFn: (rowData: any) => <>{getMoneyFormat(rowData.price)}</>
            },
            {
                accessorKey: 'eventDate',
                header: 'Event Date',
                accessorFn: (rowData: any) => <>{getDate(rowData.eventDate)}</>
            },
        ],
        [],
    );

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {

        return eventService.getAll({ ...filter })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    function handleChange(event: any) {
        setFilter((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };


    return (
        <>
            <div style={useContainerStyles.root}>

                <PageHeader
                    pageName="Events"
                    buttonName="Event"
                    onClick={() => navigate("Create")}
                    actionType="create"
                />
                <Paper>

                    <ValidatorForm onSubmit={fetchData}>
                        <StyledGrid container spacing={2}>

                            <Grid item lg={3} md={6} xs={12}>
                                <FormControl fullWidth>
                                    <TextField label="Name" name="name" value={filter.name} onChange={handleChange} placeholder="Name" variant="outlined" />
                                </FormControl>
                            </Grid>

                        </StyledGrid>
                    </ValidatorForm>

                    <CommonTable
                        columns={columns}
                        data={data}
                        filter={filter}
                        onEdit={(id: number) => {
                            navigate("Manage/" + id)
                        }}
                        setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                        isLoading={isLoading}
                    />

                    <Routes>
                        <Route path="Create" element={<EventManageDrawer emitOnSave={() => { navigate(""); fetchData(); }} emitOnClose={() => { navigate("") }} />} />
                        <Route path="Manage/:eventId" element={<EventManageDrawer emitOnSave={() => { navigate(""); fetchData(); }} emitOnClose={() => { navigate("") }} />} >
                            <Route path="EventDocuments" element={<EventDocumentUpload emitOnSave={() => { }} />} />
                            <Route path="ManageDocuments" element={<EventDocumentManage emitOnSave={() => { }} />} />
                        </Route>

                    </Routes>


                </Paper>

            </div>
        </>

    );

}
